import { Badge, Group, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

interface Item {
    locker_id: string;
    name: string;
    online?: boolean;
}

/** Плашки постаматов со ссылкой в карточку; зелёная — на связи, красная — нет. */
export function LockerBadges({ items }: { items: Item[] }) {
    const navigate = useNavigate();
    if (items.length === 0) {
        return (
            <Text c="dimmed" inherit>
                —
            </Text>
        );
    }
    return (
        <Group gap={6} justify="inherit">
            {items.map((l) => (
                <Badge
                    key={l.locker_id}
                    color={l.online === undefined ? 'gray' : l.online ? 'brand' : 'red'}
                    style={{ cursor: 'pointer', textTransform: 'none' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/lockers/${l.locker_id}`);
                    }}
                >
                    {l.name}
                </Badge>
            ))}
        </Group>
    );
}
